<template>
  <form id="invoiceForm">
    <div class="add-local-vision-appointed-datetimepicker">
      <DateTimePickerType
        v-model="value.date"
        :config="datepickerSchema.dateTimePickerOptions"
        :label="'Data wizji'"
        v-validate="{ rules: { required: datepickerSchema.required } }"
        :required="true"
        name="date"
        data-vv-as="Data wizji"
        :error-message="vErrors.first('date')"

      ></DateTimePickerType>
      <DateTimePickerType
        v-model="value.time"
        :label="'Godzina wizji'"
        :config="hourPickerSchema.dateTimePickerOptions"
        v-validate="{ rules: { required: hourPickerSchema.required } }"
        :required="true"
        name="time"
        data-vv-as="Godzina wizji"
        :error-message="vErrors.first('time')"

      ></DateTimePickerType>
    </div>
  </form>
</template>

<script>
import FormModalValidation from '../../../../share/form/FormModalValidation'
import Vue from 'vue'
import VueFormGenerator from 'vue-form-generator'
import DateTimePickerType from '@/components/share/form/type/DateTimePickerType.vue'

Vue.use(VueFormGenerator)

export default {
  components: {
    DateTimePickerType
  },
  mixins: [
    FormModalValidation
  ],
  props: {
    value: {type: Object, required: true}
  },
  data () {
    return {
      clear: false,
      datepickerSchema: {
        'type': 'dateTimePicker',
        'label': 'data wizji',
        'inputName': '',
        'disabled': false,
        'required': true,
        'relatedFields': [],
        'model': 'date',
        'readonly': false,
        validator: (value, field, model) => {
          return value ? [''] : [`${this.label} jest wymagana`]
        },

        'dateTimePickerOptions': {'format': 'YYYY-MM-DD', 'locale': this.$i18n.locale}
      },
      hourPickerSchema: {
        'type': 'dateTimePicker',
        'label': 'godzina wizji',
        'inputName': '',
        'disabled': false,
        'required': true,
        'relatedFields': [],
        'model': 'time',
        'readonly': false,
        validator: (value, field, model) => {
          return value ? [''] : [`${this.label} jest wymagana`]
        },

        'dateTimePickerOptions': {'format': 'HH:mm', 'locale': this.$i18n.locale}
      }
    }
  }
}
</script>
